module.exports = __webpack_public_path__ + "static/media/topCarouselBgVideoThumbnail.0f186308.webp";